// An article dated in the future is scheduled, not out yet. The API leaves it
// out of every list until the date, but still serves it by URL so a post queued
// in advance (Telegram, LinkedIn) can build its link preview. The article page
// uses this to keep that early URL out of search engines and out of the counts.
//
// Evaluated at request time, so the page becomes an ordinary indexed article on
// the next request after publishedAt passes. Nothing has to run at that time.
// Same rule as apps/frontend/src/utils/scheduled.ts.
export function isScheduled(publishedAt: string | Date, now: Date = new Date()): boolean {
  return new Date(publishedAt).getTime() > now.getTime();
}
